import { render, staticRenderFns } from "./ResourceSingle.vue?vue&type=template&id=b7fca2da&"
import script from "./ResourceSingle.vue?vue&type=script&lang=js&"
export * from "./ResourceSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports